import { response_type, item } from "../interfaces";

// ██╗  ██╗████████╗████████╗██████╗     ██████╗ ███████╗ ██████╗ ██╗   ██╗███████╗███████╗████████╗
// ██║  ██║╚══██╔══╝╚══██╔══╝██╔══██╗    ██╔══██╗██╔════╝██╔═══██╗██║   ██║██╔════╝██╔════╝╚══██╔══╝
// ███████║   ██║      ██║   ██████╔╝    ██████╔╝█████╗  ██║   ██║██║   ██║█████╗  ███████╗   ██║
// ██╔══██║   ██║      ██║   ██╔═══╝     ██╔══██╗██╔══╝  ██║▄▄ ██║██║   ██║██╔══╝  ╚════██║   ██║
// ██║  ██║   ██║      ██║   ██║         ██║  ██║███████╗╚██████╔╝╚██████╔╝███████╗███████║   ██║
// ╚═╝  ╚═╝   ╚═╝      ╚═╝   ╚═╝         ╚═╝  ╚═╝╚══════╝ ╚══▀▀═╝  ╚═════╝ ╚══════╝╚══════╝   ╚═╝
//                      H       T       T       P           請          求

declare var post_processes: Function;

export default function http_request_worker(
  url: string,
  role: string,
  index: number,
  hostname: string,
  method_id: number,
  datacenter_name: string,
  cluster_name: string | undefined,
  namespace_name: string | undefined,
  body?: string,
  kind?: string,
  old_data?: any[] | undefined,
  no_info?: boolean,
  subscription_id?: string,
  cluster_session?: string,
  workspace_session?: string,
  unit_provide?: string,
  page?: string,
  db_data?: response_type
): Promise<any> {
  const method: string = ["GET", "POST", "PUT", "DELETE", "PATCH"][method_id];
  let response_code: number;
  return fetch(
    `${origin}${url}`,
    url.includes("/api/search")
      ? {
          headers: {
            "X-Grafana-Org-Id": "1",
          },
        }
      : Object.assign(
          {
            method,
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              credentials: "include",
            },
          },
          body && (method_id === 1 || method_id === 2) ? { body } : {}
        )
  )
    .then(
      (response: Body): Promise<response_type> => {
        response_code = (response as any).status;
        return response.json();
      }
    )
    .then((response: response_type) => {
      if (response_code >= 400) {
        response.code = response_code;
      } else if (typeof response.status === "number") response.code = response.status;
      // 如果回傳401錯誤，即驗證失敗，導回SSO頁面
      // if (response.message && response.status === 401) redirect(response.message, hostname);
      // 处理sso接口返回值
      if (!response.hasOwnProperty("items") && response.hasOwnProperty("resources")) {
        response.items = response.resources;
        delete response.resources;
      }

      response.items &&
        response.items
          .sort((a: item, b: item) => {
            const metadata: item["metadata"] = a.metadata,
              metadata_b: item["metadata"] = b.metadata;
            return metadata?.labels?.name
              ? metadata.labels.name.localeCompare(metadata_b?.labels?.name?.toLocaleLowerCase() || "")
              : metadata?.name.localeCompare(metadata_b?.name.toLocaleLowerCase() || "") || 0;
          })
          .forEach((item_each: item) => {
            const metadata_org: item["metadata"] = item_each.metadata;
            if (metadata_org) {
              const labels_old = item_each.metadata?.labels;
              if (item_each.metadata) {
                kind && (metadata_org.key = kind.substr(0, kind.length - 1));
                const metadata_db = db_data?.items?.find(({ metadata }: item) => metadata?.name === item_each.metadata?.name)?.metadata;
                metadata_db && (item_each.metadata = metadata_db);
                item_each.metadata.labels = labels_old;
              }
            }
          });
      response.kind = kind;
      return new Promise((resolve) => {
        const post_process: Function = post_processes()[kind || ""];
        // 處理後將結果回傳給主線程
        if (post_process) {
          post_process({
            url,
            response,
            page,
            old_data,
            index,
            hostname,
            kind,
            no_info,
            role,
            datacenter_name,
            cluster_name,
            namespace_name,
            subscription_id,
            cluster_session,
            workspace_session,
            db_data,
            unit_provide,
          })
            .then((result: unknown) => {
              resolve({
                original_response: response,
                result,
              });
            })
            .catch((err: any) => {
              console.error(err);
              resolve({ result: response });
            });
        }
        // 不處理，將結果回傳給主線程
        else resolve({ result: response });
      });
    })
    .catch((err) => {
      console.error(err);
      const post_process: Function = post_processes()[kind || ""];
      // 處理後將結果回傳給主線程
      return post_process ? old_data : { code: response_code };
    });
}
